/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ITilesContainerViewProps } from './tiles-container';

export default (props: ITilesContainerViewProps) => {
    const { slots } = props;
    const tiles = slots?.tiles || [];

    if (!tiles || tiles.length === 0) {
        return (
            <div className='tiles-container'>
                <div className='tiles-container__placeholder'>
                    <p>Please add category tiles in Site Builder (minimum 4, maximum 5)</p>
                </div>
            </div>
        );
    }

    return (
        <div className='tiles-container'>
            <div className='container'>
                <div className='tiles-container__wrapper'>
                    {tiles.map((tile, index) => (
                        <React.Fragment key={index}>{tile}</React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};
